import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import { useForm } from '../../../../packages/kiti/components/form/form/FormHandler'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import Line from '../../../../packages/kiti/components/helpers/Line'
import Switch from '../../../../components/form/Switch'

const ControlInfoSection = () => {
  const { t } = useTranslation('editStocks')
  const form = useForm()

  return (
    <>
      <Separator weight={2} />
      <Title size="small" bold color="dark3">
        {t('sections.controlInfo')}
      </Title>
      <Line />
      <Separator weight={2} />
      <Grid paddingGutter={0.5} wrap>
        <Col width="50%" wrapOn="sm">
          <FormItem label={t('fields.enabled')} field="enabled" Input={Switch} disabled={true} value={form.enabled} />
        </Col>
      </Grid>
    </>
  )
}

export default ControlInfoSection
